var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettlementHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-successful-purchase",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#freepik_stories-successful-purchase:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#freepik_stories-successful-purchase.animated #freepik--background-complete--inject-14 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) fadeIn;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-successful-purchase.animated #freepik--Floor--inject-14 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-successful-purchase.animated #freepik--Character--inject-14 {\n      animation: 1.5s Infinite linear wind;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-successful-purchase.animated #freepik--Device--inject-14 {\n      animation: 1.5s Infinite linear floating;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-successful-purchase.animated #freepik--Plant--inject-14 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    @keyframes fadeIn {\n      0% {\n        opacity: 0;\n      }\n\n      100% {\n        opacity: 1;\n      }\n    }\n\n    @keyframes slideUp {\n      0% {\n        opacity: 0;\n        transform: translateY(30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: inherit;\n      }\n    }\n\n    @keyframes wind {\n      0% {\n        transform: rotate(0deg);\n      }\n\n      25% {\n        transform: rotate(1deg);\n      }\n\n      75% {\n        transform: rotate(-1deg);\n      }\n    }\n\n    @keyframes floating {\n      0% {\n        opacity: 1;\n        transform: translateY(0px);\n      }\n\n      50% {\n        transform: translateY(-10px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: translateY(0px);\n      }\n    }\n\n    .animator-hidden {\n      display: none;\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-14",
    className: "animable",
    style: {
      transformOrigin: "283.597px 250.876px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.12,275.13s-9.08,2.4-1.44,22,13.3,29.5,13.3,29.5,1.25,4.5-2.46,4.8-11.61-1.78-13.68,2.52.77,9.15,7.2,13.66,20.14,14.92,21.38,15.86,2.31,3.08-.19,3.69-20.73.68-20.18,9.33,20.52,18.28,22.68,19.38,2.6,2.1,2.3,3.31-6.44.67-11.63.9-11.16,1.41-10.42,6.37,12,16.38,41.5,22.29l13.86,1.85,8.75-11c17.28-24.65,17.56-40.67,14.67-44.77s-8-.84-11.95,2.57-8,8-9,7.38-1.44-1.71-.63-4,8.63-23,3.06-29.67-18.82,5.89-21.05,7.16-2.92-1-2.68-2.54,3-18.53,4.54-26.23.41-13.11-4.22-14.86c-4.46-1.68-8.74,5.28-11.64,7.62s-5.09-1.78-5.09-1.78-2.73-11.07-10.72-30.53-16.41-14.78-16.41-14.78",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "147.156px 352.628px"
    },
    id: "elbbtppdxdm4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.73,433.93C162.92,419.62,153,394,144.39,372.05s-16.43-41.8-22.17-56.14c-2.88-7.15-5.2-13-6.82-17l-1.85-4.62-.47-1.2a4,4,0,0,1-.15-.42s.07.13.19.4.29.68.51,1.19l1.93,4.59c1.66,4,4,9.77,6.94,16.93,5.81,14.31,13.68,34.15,22.3,56.1s18.47,47.58,24.22,61.92",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.975px 363.3px"
    },
    id: "eljre1opo2fdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,337.31a4.58,4.58,0,0,1,.94.37c.6.26,1.45.66,2.49,1.16,2.09,1,4.94,2.49,8.06,4.18l8,4.34,2.42,1.29a4.65,4.65,0,0,1,.87.52,6.13,6.13,0,0,1-.95-.36c-.59-.26-1.44-.67-2.48-1.18-2.08-1-4.91-2.55-8-4.23l-8-4.28-2.42-1.29A3.89,3.89,0,0,1,112.77,337.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "124.16px 343.24px"
    },
    id: "elqjwyd47b1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,348.37c-.11-.05,2.67-6.06,6.21-13.42s6.49-13.29,6.6-13.24-2.67,6.07-6.21,13.43S136.66,348.43,136.55,348.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "142.955px 335.04px"
    },
    id: "eld12ocedzgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.26,382.67a5,5,0,0,1,.65-.8l1.88-2.09c1.58-1.76,3.75-4.21,6-7s4.3-5.37,5.73-7.26c.68-.88,1.24-1.63,1.7-2.23a4.45,4.45,0,0,1,.66-.79,4.24,4.24,0,0,1-.52.89c-.37.55-.9,1.35-1.59,2.32-1.37,1.93-3.33,4.56-5.64,7.35s-4.52,5.22-6.16,6.93c-.82.85-1.49,1.54-2,2A4.63,4.63,0,0,1,148.26,382.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.57px 372.585px"
    },
    id: "eljakcjq6o96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55,377.4a3.92,3.92,0,0,1,1,.11l2.55.46c2.15.41,5.12,1,8.39,1.69s6.22,1.33,8.36,1.81l2.52.6a4,4,0,0,1,.92.28,3.89,3.89,0,0,1-1-.11l-2.55-.47c-2.16-.41-5.12-1-8.39-1.68s-6.23-1.33-8.36-1.82l-2.53-.59A3.79,3.79,0,0,1,124.55,377.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "136.42px 379.875px"
    },
    id: "el8selhe5o9ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,409a6.67,6.67,0,0,1,1.22.16l3.27.58c2.76.51,6.57,1.24,10.76,2.07s8,1.62,10.75,2.21l3.24.71a6.43,6.43,0,0,1,1.18.32,6,6,0,0,1-1.21-.15l-3.27-.58c-2.76-.51-6.57-1.24-10.77-2.08s-8-1.62-10.74-2.2l-3.25-.72A7.15,7.15,0,0,1,131,409Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.21px 412.025px"
    },
    id: "elv0wdorhl3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,414.69a7.06,7.06,0,0,1,.79-1l2.28-2.73c1.93-2.31,4.57-5.51,7.39-9.13s5.29-6.94,7.06-9.37l2.1-2.88a8.16,8.16,0,0,1,.81-1,6.57,6.57,0,0,1-.67,1.12c-.46.71-1.13,1.72-2,3-1.71,2.47-4.14,5.84-7,9.46s-5.51,6.79-7.49,9.06c-1,1.12-1.81,2-2.39,2.64A7.68,7.68,0,0,1,160.78,414.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "170.995px 401.635px"
    },
    id: "eloe79ydw9ivb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0ckuoec91ky"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.83,
    y: 304.44,
    width: 97.12,
    height: 149.35,
    rx: 7.54,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "386.39px 379.115px",
      transform: "rotate(-31.14deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.85,410.77a10.31,10.31,0,1,1,3.49-14.15A10.3,10.3,0,0,1,435.85,410.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "430.516px 401.948px"
    },
    id: "elxx2k5boufbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,423.39a10.46,10.46,0,0,1-2.6-.32,10.72,10.72,0,1,1,2.6.32Zm0-20.62a9.81,9.81,0,0,0-8.38,14.88A9.83,9.83,0,0,0,442,421h0a9.81,9.81,0,0,0-2.73-17.92A9.47,9.47,0,0,0,436.93,402.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "437px 412.67px"
    },
    id: "elkwzgjgt2c88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,333.62l-7.1,4.28-.44-.72,6.45-3.9-1-1.67.65-.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "339.23px 334.56px"
    },
    id: "elt40184vgvdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,344.81l-.65.39-3-5,.51-.32,4.67,1.21a2.73,2.73,0,0,0,2.33-.11c.82-.5,1-1.38.33-2.46a2.85,2.85,0,0,0-2-1.46l.13-.79a3.73,3.73,0,0,1,2.53,1.9c.87,1.44.69,2.8-.49,3.51a3.42,3.42,0,0,1-2.93.18l-3.83-1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "341.872px 340.735px"
    },
    id: "eljmwbusra5en",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.73,351.55l-.86-1.42L344,351.25l-.44-.73,1.86-1.12-2.42-4,.53-.32,7,.92.49.81-6.77-.86,1.86,3.08,1.64-1,.43.71-1.64,1,.86,1.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "347.01px 348.315px"
    },
    id: "elh55icvzy04r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,362.42l-.86-1.42-1.86,1.13-.44-.73,1.86-1.13-2.42-4,.53-.32,7,.92.49.81-6.77-.86,1.86,3.08,1.65-1,.42.71-1.64,1L354,362Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "353.59px 359.185px"
    },
    id: "el1iucrd1qusw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.27,368.49c-1.2.73-2.66.45-3.7-1.28a4.3,4.3,0,0,1-.63-3.09h.79a3.61,3.61,0,0,0,.5,2.68c.73,1.2,1.7,1.49,2.56,1s1.14-1.46,0-3.27l-.91-1.51,3.78-1.78,2.34,3.88-.65.39-2-3.24-2.4,1.12.55.91C358.88,366.41,358.53,367.73,357.27,368.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "357.437px 365.054px"
    },
    id: "elninlqv5g9sc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,375.48a2.58,2.58,0,0,1-3.64-1.1c-1.14-1.89-.45-3.7,1.79-5.06,2.41-1.45,4.46-.89,5.62,1a3.84,3.84,0,0,1,.64,1.92l-.77.06a2.9,2.9,0,0,0-.5-1.58c-.92-1.53-2.5-1.92-4.42-.76a6.21,6.21,0,0,0-.56.38,2.63,2.63,0,0,1,2.52,1.44A2.5,2.5,0,0,1,361.54,375.48Zm-.46-.7a1.82,1.82,0,0,0,.46-2.71,1.82,1.82,0,1,0-3,1.9A1.81,1.81,0,0,0,361.08,374.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "361.654px 372.17px"
    },
    id: "elpeycmu2fhxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.32,385.24c-1.18.72-2.61.41-3.65-1.31a4.27,4.27,0,0,1-.63-3.1h.79a3.63,3.63,0,0,0,.51,2.7c.71,1.18,1.65,1.49,2.53,1s1.05-1.45.25-2.77l-.3-.5.53-.33,3.65.48-2.19-3.63.65-.39,2.76,4.56-.52.31-3.74-.48C368.8,383.31,368.46,384.56,367.32,385.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "367.596px 381.496px"
    },
    id: "el76isiio9t3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,392.31a2.58,2.58,0,0,1-3.64-1.11c-1.14-1.88-.45-3.7,1.79-5.05,2.41-1.46,4.47-.9,5.63,1a3.86,3.86,0,0,1,.63,1.91l-.76.06a3,3,0,0,0-.5-1.58c-.93-1.53-2.5-1.92-4.43-.75-.16.09-.36.23-.56.37a2.68,2.68,0,0,1,2.53,1.44A2.51,2.51,0,0,1,371.7,392.31Zm-.45-.71a1.82,1.82,0,0,0,.45-2.71,1.83,1.83,0,1,0-3,1.91A1.82,1.82,0,0,0,371.25,391.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "371.814px 388.996px"
    },
    id: "elvp61k2umram",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.62,395.83l-.51.31-8.38,1-.47-.79,8.21-1-2.21-3.65-1.32.8-.44-.72,2-1.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "375.94px 393.865px"
    },
    id: "elvx4ykcjsqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.75,406l-.51.31-8.38,1-.47-.79,8.21-1-2.21-3.65-1.33.81-.43-.72,2-1.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "382.07px 404.035px"
    },
    id: "eluuholt93jmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85,416.05c-1.25.76-2.68.16-3.7-1.53s-.87-3.21.38-4a2.08,2.08,0,0,1,2.58.32,1.86,1.86,0,0,1,.88-2.06c1.16-.7,2.47-.15,3.38,1.35s.79,2.94-.36,3.64a1.9,1.9,0,0,1-2.25-.19A2.1,2.1,0,0,1,385.85,416.05Zm-.44-.76c.87-.53,1-1.61.21-2.86s-1.76-1.67-2.63-1.14-1,1.6-.22,2.86S384.53,415.82,385.41,415.29Zm.78-3.21c.67,1.1,1.57,1.46,2.34,1s.86-1.48.22-2.55-1.55-1.45-2.34-1S385.53,411,386.19,412.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "385.725px 412.427px"
    },
    id: "elu4itgqh4c5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,422c-2.41,1.46-4.47.9-5.63-1a3.92,3.92,0,0,1-.63-1.92l.76-.06a3,3,0,0,0,.5,1.58c.93,1.53,2.5,1.92,4.43.76.16-.1.36-.23.56-.38a2.67,2.67,0,0,1-2.53-1.44,2.5,2.5,0,0,1,.69-3.67,2.57,2.57,0,0,1,3.64,1.1C394.58,418.79,393.89,420.6,391.65,422Zm.8-1.85a1.93,1.93,0,0,0,.39-2.8,1.81,1.81,0,1,0-3,1.91A1.91,1.91,0,0,0,392.45,420.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "389.686px 419.166px"
    },
    id: "elkegep3fy36h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.48,427l-7.09,4.29-.44-.73,6.44-3.9-1-1.67.65-.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "395.715px 427.945px"
    },
    id: "elo7pmsfpfapj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.45,438.23l-.65.4-3-5,.52-.31,4.67,1.2a2.74,2.74,0,0,0,2.33-.11c.82-.49,1-1.38.32-2.46a2.81,2.81,0,0,0-2-1.46l.13-.78a3.71,3.71,0,0,1,2.54,1.9c.87,1.44.69,2.79-.5,3.51a3.4,3.4,0,0,1-2.92.17l-3.83-1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "398.327px 434.17px"
    },
    id: "elfev6q61ycun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.68,443.76c-1.19.72-2.62.41-3.65-1.31a4.27,4.27,0,0,1-.63-3.1h.79a3.63,3.63,0,0,0,.51,2.7c.71,1.17,1.65,1.49,2.53,1s1-1.45.25-2.77l-.31-.51.54-.32,3.65.48-2.19-3.63.65-.39,2.75,4.56-.51.31-3.74-.48C404.16,441.83,403.82,443.07,402.68,443.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "402.951px 440.016px"
    },
    id: "elrhpe2z0f94s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el25tvw57qch2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.25,
    y: 389.75,
    width: 3.6,
    height: 66.41,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.05px 422.955px",
      transform: "rotate(-31.1593deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el390l7tsniuq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.46,
    y: 423.48,
    width: 3.6,
    height: 34.06,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "380.26px 440.51px",
      transform: "rotate(-31.14deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8rvk5ls76zs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.68,
    y: 321.66,
    width: 27.86,
    height: 20.82,
    rx: 4.96,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "362.61px 332.07px",
      transform: "rotate(58.86deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.43,322.54l1.14-.69L360,334.13a3,3,0,1,0,5.14-3.1l-7.42-12.28,1.14-.69,7.42,12.28a4.33,4.33,0,0,1-7.42,4.48Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "359.167px 327.487px"
    },
    id: "el0q3szsbdz3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliumibahapw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.34,
    y: 335.01,
    width: 1.34,
    height: 9.85,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "367.01px 339.935px",
      transform: "rotate(-31.1593deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf4mx3c2bye4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.74,
    y: 337.9,
    width: 71.66,
    height: 6.15,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "396.57px 340.975px",
      transform: "rotate(58.86deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,33.61c-.76,10.8,0,30.92-3.93,41s-9.18,20.48-19,25c-12.12,5.56-26.36,3.2-39.29,6.46-20.26,5.1-34.92,23.69-41.17,43.63s-5.56,41.3-4.81,62.18L204.5,226.22s.54-42,9.56-53.49,51.87-21.8,66-53.21c12.74-28.27,16.58-73.1,16.58-73.1Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "198.632px 129.915px"
    },
    id: "elphtxhmjgkod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.56,62l-1.34-2.47a3.69,3.69,0,0,1-.56,0l-1.9-.23-.28,2.24-.74-.09.87-7.07,2.64.33c1.8.22,2.77,1.27,2.59,2.78a2.21,2.21,0,0,1-1.89,2l1.42,2.63Zm.53-4.64c.14-1.13-.53-1.87-1.94-2l-1.88-.23-.43,3.54,1.87.23C234.13,59,235,58.48,235.09,57.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "232.801px 58.25px"
    },
    id: "els5x1oupdj3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,62.29l-.08.64-5-.61.87-7.06,4.84.59-.08.65L238.57,56l-.31,2.52,3.65.45-.08.63-3.65-.45-.33,2.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "239.875px 59.095px"
    },
    id: "el6llysc20m4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,59.54a3.58,3.58,0,0,1,4.15-3.14,3.45,3.45,0,0,1,2.45,1.35l-.53.42a2.79,2.79,0,0,0-2-1.1,2.95,2.95,0,1,0-.73,5.85,2.78,2.78,0,0,0,2.2-.59l.41.54a3.48,3.48,0,0,1-2.72.71A3.58,3.58,0,0,1,243.54,59.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.824px 59.9878px"
    },
    id: "elrnzup9ytq0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,64l-.08.65L251,64l.87-7.06,4.84.6-.08.64-4.1-.5-.31,2.51,3.65.45-.07.64-3.65-.45-.33,2.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "253.855px 60.795px"
    },
    id: "el4syzztjq8go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,57.81l.74.1L258.48,65l-.75-.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "258.54px 61.405px"
    },
    id: "elvhck3cfraak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88,61.29c-.19,1.51-1.39,2.28-3.18,2.06l-1.9-.24-.27,2.23-.75-.09.87-7.06,2.64.33C266.09,58.74,267.07,59.78,266.88,61.29Zm-.75-.09c.14-1.13-.52-1.86-1.94-2l-1.87-.23-.44,3.53,1.88.23C265.17,62.87,266,62.31,266.13,61.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "263.842px 61.765px"
    },
    id: "elvye56p29fll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.85,59.86l-2.48-.31.08-.64,5.71.7-.08.65L270.6,60l-.79,6.42-.75-.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.265px 62.665px"
    },
    id: "el99gsj9o5xku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.68,79.25c0,.15-9.45-1-21.05-2.6s-21-3-21-3.12,9.44,1,21,2.6S258.69,79.11,258.68,79.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "237.655px 76.3922px"
    },
    id: "elhenfrh8ebew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,87.67c0,.15-9.44-1-21-2.6s-21-3-21-3.12,9.44,1,21,2.6S257.56,87.53,257.54,87.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "236.54px 84.8122px"
    },
    id: "el1osw4abs85g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.69,96.26c0,.14-9.44-1-21-2.6s-21-3-21-3.13,9.43,1,21,2.61S253.71,96.12,253.69,96.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "232.69px 93.3957px"
    },
    id: "elzz37z44qfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.68,104.92c0,.15-9.44-1-21.05-2.6s-21-3-21-3.12,9.44,1,21.05,2.6S246.7,104.78,246.68,104.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "225.655px 102.062px"
    },
    id: "el7bwpx3g05hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,113.57c0,.14-9.44-1-21-2.61s-21-3-21-3.12,9.44,1,21,2.61S235.53,113.42,235.51,113.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "214.51px 110.706px"
    },
    id: "el7ubv33n17w8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.51,82.06a52.46,52.46,0,0,1-10.26-1.67,26.6,26.6,0,0,1,5.18.58A26.06,26.06,0,0,1,277.51,82.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "272.38px 81.225px"
    },
    id: "el9st060n97wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.15,89.57A26.6,26.6,0,0,1,272,89a26.06,26.06,0,0,1-5.08-1.09,24.85,24.85,0,0,1,5.17.58A26.51,26.51,0,0,1,277.15,89.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "272.035px 88.74px"
    },
    id: "elob8xlx627z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,100a26.78,26.78,0,0,1-5.18-.6,31.75,31.75,0,0,1-5.08-1.07c0-.18,2.34.09,5.17.55A26,26,0,0,1,274.6,100Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "269.47px 99.1369px"
    },
    id: "eloots2uq8xp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.92,108.75a26.78,26.78,0,0,1-5.18-.6,32.08,32.08,0,0,1-5.08-1.07c0-.18,2.34.09,5.17.55A25.79,25.79,0,0,1,270.92,108.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.79px 107.887px"
    },
    id: "el4ovc2hx8b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,117.1a26.71,26.71,0,0,1-5.18-.6,30.49,30.49,0,0,1-5.08-1.07c0-.18,2.34.09,5.16.56A26.47,26.47,0,0,1,263,117.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "257.87px 116.237px"
    },
    id: "eluzgjka7h6qq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,124.13c0,.14-14.16-1.74-31.58-4.21s-31.54-4.58-31.52-4.72,14.16,1.74,31.59,4.21S226,124,226,124.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "194.45px 119.665px"
    },
    id: "elvmcrzlrp99b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,133a6.07,6.07,0,0,1-.7-.06l-2-.26-7.3-1.07-24.06-3.7c-9.39-1.48-17.88-2.86-24-3.89l-7.27-1.25c-.86-.16-1.52-.28-2-.38a3.09,3.09,0,0,1-.68-.18,4.46,4.46,0,0,1,.7.08l2,.28,7.3,1.09,24.06,3.73,24,3.86,7.27,1.23,2,.36A2.8,2.8,0,0,1,218.66,133Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "184.655px 127.605px"
    },
    id: "el1m5l918jbov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.46,141.06a11.74,11.74,0,0,1-2.6-.23c-1.69-.22-4.14-.56-7.17-1-6.05-.87-14.4-2.14-23.61-3.58s-17.56-2.79-23.59-3.79l-7.14-1.2-1.93-.36a3.05,3.05,0,0,1-.67-.16,2.89,2.89,0,0,1,.68.06l1.95.25,7.17,1,23.61,3.63,23.59,3.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "172.105px 135.901px"
    },
    id: "el5lq1fa32t96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79,129a26.78,26.78,0,0,1-5.18-.6,32.08,32.08,0,0,1-5.08-1.07c0-.18,2.34.09,5.17.55A25.57,25.57,0,0,1,249.79,129Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "244.66px 128.137px"
    },
    id: "eloxscg0c62fq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,134.66a26.78,26.78,0,0,1-5.18-.6,32.08,32.08,0,0,1-5.08-1.07c0-.18,2.34.09,5.17.55A25.57,25.57,0,0,1,239.6,134.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "234.47px 133.797px"
    },
    id: "elox1aur4ps1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.88,144.21a26.78,26.78,0,0,1-5.18-.6,30.79,30.79,0,0,1-5.08-1.07c0-.18,2.34.09,5.17.56A26,26,0,0,1,225.88,144.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "220.75px 143.347px"
    },
    id: "eliiwzycd92dp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.66,159.29c0,.15-17.51-2.43-39-5.74s-39-6.12-39-6.26,17.5,2.43,39,5.75S199.68,159.15,199.66,159.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "160.66px 153.29px"
    },
    id: "el8yyhhjcyun6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.19,178.22c0,.14-5.76-.67-12.8-1.81s-12.74-2.18-12.72-2.32,5.76.67,12.8,1.81S189.21,178.07,189.19,178.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "176.43px 176.155px"
    },
    id: "elrkwj8zhoihj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14",
    className: "animable",
    style: {
      transformOrigin: "250px 463.75px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.41,463.75c0,.15-96.45.26-215.4.26s-215.42-.11-215.42-.26,96.43-.26,215.42-.26S465.41,463.61,465.41,463.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 463.75px"
    },
    id: "elpagfwac4z1j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14",
    className: "animable",
    style: {
      transformOrigin: "98.4426px 288.165px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.49,124.52l.08,4s1.63,31,1.53,35.66-15.65,31.25-15.65,31.25L137,211l22.8-41-5.46-44-.14-1.09",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "143.625px 167.76px"
    },
    id: "eldgfa4mimg5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.07,119.73,150,108.44l-12,6.94c0,1,3.59,9.14,3.59,9.14l2.08,2.16s10.43-1.1,10.65-1.21S153.07,119.73,153.07,119.73Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "146.171px 117.56px"
    },
    id: "elepav76ek6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,109.24s.07.09.12.24c.46,1.22,1.8,6.73,1.19,7.14s-2.67.51-3-.18-1.47-7-1.47-7-.12-1,1.46-1.67C149.65,107.39,150.37,109.24,150.37,109.24Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "149.522px 112.331px"
    },
    id: "el44b1f0pjfbn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.57,108.12s.07.09.12.23c.46,1.23,1.8,6.73,1.19,7.14s-2.67.51-3-.18-1.47-7-1.47-7-.11-1,1.46-1.66C145.85,106.26,146.57,108.12,146.57,108.12Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "145.722px 111.205px"
    },
    id: "elto1lpzb58bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,108a.58.58,0,0,1,.12.24c.46,1.22,1.79,6.73,1.18,7.14s-2.66.51-3-.18-1.47-7-1.47-7-.12-1,1.46-1.66C142.38,106.11,143.1,108,143.1,108Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "142.243px 111.09px"
    },
    id: "el5pezn60zups",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.66,107.86a.58.58,0,0,1,.12.24c.46,1.22,1.79,6.73,1.18,7.14s-2.67.51-3-.18-1.47-7-1.47-7-.12-1,1.46-1.66C138.94,106,139.66,107.86,139.66,107.86Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "138.803px 110.953px"
    },
    id: "elmnp27406ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,114.84a10.77,10.77,0,0,0-.43-2.74,10.83,10.83,0,0,0-.76-2.62,10.77,10.77,0,0,0,.43,2.74A10.83,10.83,0,0,0,148.25,114.84Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "147.655px 112.16px"
    },
    id: "elvanqc5y7ygl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,115.69a20.87,20.87,0,0,0-.67-3.87,20.45,20.45,0,0,0-1-3.8,23.26,23.26,0,0,0,.67,3.87A22.85,22.85,0,0,0,145,115.69Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "144.165px 111.855px"
    },
    id: "el3f2wlavbuov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldm0l00ekel"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.78,
      transformOrigin: "140.835px 112.43px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.67,116.27a23.29,23.29,0,0,0-.67-3.88,22.85,22.85,0,0,0-1-3.8,21,21,0,0,0,.67,3.88A20.75,20.75,0,0,0,141.67,116.27Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "140.835px 112.43px"
    },
    id: "elfhmlin9ents",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,123.42l-3.64-2.94a7.93,7.93,0,0,1-2.89-5.17l-.2-1.55,11-2.22s0,4.09-3.1,4.14l3.87,2Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "143.425px 117.48px"
    },
    id: "eldcit97sdfjv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,118.47c-.05,0-.29-.45-.95-1.06a5.1,5.1,0,0,0-3.34-1.35h-1.18l1.11-.41,2.54-.94,0,0a3,3,0,0,0,1.58-2.84,1.5,1.5,0,0,0-.05-.26l.31.17c-3.07.76-5.85,1.4-7.88,1.75-1,.18-1.84.29-2.42.36a3.17,3.17,0,0,1-.89,0,31.94,31.94,0,0,1,3.23-.76c2-.43,4.76-1.13,7.83-1.89l.24-.06.07.23a2.49,2.49,0,0,1,.08.35,3.09,3.09,0,0,1-.47,2,4.37,4.37,0,0,1-1.37,1.31l0,0h0l-2.57.88-.07-.42a5.11,5.11,0,0,1,3.52,1.61A2.67,2.67,0,0,1,148.78,118.47Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "143.344px 114.825px"
    },
    id: "el5cy5gffg61j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.11,113.38c.09,0,.27.5.83,1a.94.94,0,0,0,1.09.16,1.43,1.43,0,0,0,.49-1.36c-.13-1.24-.2-2.4-.31-3.2s-.25-1.31-.17-1.34.31.44.53,1.27a24.63,24.63,0,0,1,.47,3.24,1.84,1.84,0,0,1-.76,1.8,1.33,1.33,0,0,1-1.59-.29,2.4,2.4,0,0,1-.52-.9C148.1,113.53,148.08,113.4,148.11,113.38Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "149.58px 111.867px"
    },
    id: "elzob17lyg22g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,149.66c2.66-.16,5.13,1.46,7,3.4s3.25,4.24,5.16,6.11c1.42,1.39,3.14,2.59,4,4.38,1.37,2.86.22,6.55,2,9.21,1,1.49,2.69,2.37,3.7,3.84,1.25,1.85,1.16,4.27.88,6.49a7.57,7.57,0,0,1-1.57,4.3,7.4,7.4,0,0,1-3.15,1.74,45,45,0,0,1-27,.58",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "117.697px 170.576px"
    },
    id: "el1g60tgmn5m7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,167.49a13.75,13.75,0,0,1,12.35-15.4,14,14,0,0,1,14.94,12,144,144,0,0,1,1.76,15.16c-.09,7.06-4.22,9.8-5.89,10.63a9,9,0,0,1-1.86.46h0s0,0,0,.05l1.57,8.1c.71,5.31-2.25,10-7.55,10.81s-9.47-3.3-10.28-8.61Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "106.872px 180.725px"
    },
    id: "eldtwiikw2gid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,168.26c-.11.16-1-.34-2.24-.16s-2,.9-2.13.77,0-.33.37-.67a3.11,3.11,0,0,1,1.68-.8,3,3,0,0,1,1.81.31C118.37,167.94,118.53,168.18,118.47,168.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.267px 168.128px"
    },
    id: "eldh1o1sc061t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,170.56c-.12.16-1-.34-2.24-.16s-2,.9-2.14.78,0-.34.37-.67a3,3,0,0,1,1.69-.8,2.91,2.91,0,0,1,1.81.3C107.74,170.24,107.91,170.48,107.85,170.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "105.639px 170.434px"
    },
    id: "elta18apct2ie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,176.2a8.49,8.49,0,0,1,1.89-.63c.3-.08.58-.18.6-.39a1.61,1.61,0,0,0-.34-.88l-1.24-2.19a41.33,41.33,0,0,1-2.91-5.78,39.59,39.59,0,0,1,3.37,5.53c.42.77.82,1.51,1.21,2.21a1.83,1.83,0,0,1,.33,1.18.8.8,0,0,1-.44.52,2.24,2.24,0,0,1-.5.14A7.35,7.35,0,0,1,112,176.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "112.457px 171.265px"
    },
    id: "elyfg3txvr20q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,190.39s-4.55,1.05-10.82-1.58c0,0,2.7,5.83,11.25,3.76Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "108.455px 190.912px"
    },
    id: "elzex9kex3jip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89,179.15a2.17,2.17,0,0,0-2-.51,2,2,0,0,0-1.25.92,1.28,1.28,0,0,0,.11,1.44,1.49,1.49,0,0,0,1.63.17,4.74,4.74,0,0,0,1.39-1.14,1.41,1.41,0,0,0,.29-.4.39.39,0,0,0-.07-.44",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "110.284px 179.956px"
    },
    id: "el3qcc6thvws5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,177.54c.19,0,.38,1.26,1.62,2s2.61.41,2.64.59-.27.3-.85.4a3.24,3.24,0,0,1-2.19-.43,2.8,2.8,0,0,1-1.28-1.7C108.4,177.89,108.5,177.55,108.59,177.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.66px 179.055px"
    },
    id: "el32fb03fsykp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,166.67c-.07.35-1.29.36-2.67.74s-2.45.92-2.68.65c-.1-.12,0-.46.46-.84a4.81,4.81,0,0,1,4.07-1.06C106.76,166.29,107.05,166.51,107,166.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "104.31px 167.1px"
    },
    id: "elrwsihnehhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.27,164.58c-.17.3-1,.14-2,.27s-1.8.45-2,.19,0-.42.31-.73a2.93,2.93,0,0,1,1.58-.68,2.78,2.78,0,0,1,1.69.31C117.18,164.17,117.34,164.43,117.27,164.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.238px 164.372px"
    },
    id: "el2h9jfkwsjdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,162.55c-1.46,2.23-6.09.85-8.89-.68A6.64,6.64,0,0,1,103.1,160c-1.6,2-4.85,1.37-6-.93s-.52-5.46,1.11-7.47a10.41,10.41,0,0,1,6.36-3.46,14.75,14.75,0,0,1,15,6.17c1.54,2.33,2.47,5.46,1.55,8.25",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.999px 155.794px"
    },
    id: "el8h58to62vug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.59,151.43c-5.25-1-10.31,4.23-10.84,8-.91,6.5,0,7.31-1.22,10.42-.77,2-3.44,4.1-4.49,6.19-1.14,2.24-1.13,6-.34,8.42.66,2,3.37,7.63,3.37,7.63s7.8-.25,11.79-1.27a6.67,6.67,0,0,0,2.82-1.32c.76-.69-.81-3.07-.66-4.08.41-2.88,2.56-4.55,2-7.39-.82-3.77-3.79-4-3.73-7.83,0-2,3.09-5,3.37-7s1.46-9.1-2-11.72",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.1267px 171.698px"
    },
    id: "elohcpegn7fi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.71,192.3s-.38-.44-1-1.24a17.26,17.26,0,0,1-2.32-3.69,12.21,12.21,0,0,1-1.14-6.26,9.92,9.92,0,0,1,3.46-6.8c1.08-.87,2.31-1.53,3.36-2.41a6.61,6.61,0,0,0,2.19-3.26,21.61,21.61,0,0,0,.65-3.47,16,16,0,0,1,.59-2.95A5.15,5.15,0,0,1,98.13,159a4.31,4.31,0,0,1,1.55-.32,1.16,1.16,0,0,0-.42-.06,3.11,3.11,0,0,0-1.2.22,5.17,5.17,0,0,0-2.9,3.27,15.05,15.05,0,0,0-.67,3,20.76,20.76,0,0,1-.68,3.39,6.06,6.06,0,0,1-2.07,3c-1,.84-2.24,1.49-3.37,2.41a10.24,10.24,0,0,0-3.58,7.11,12.41,12.41,0,0,0,1.26,6.44,16,16,0,0,0,2.48,3.67c.35.38.65.67.85.85A1.63,1.63,0,0,0,89.71,192.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "92.2179px 175.459px"
    },
    id: "elk4wrg08djgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,188.9s.08-.09.2-.28a8.8,8.8,0,0,0,.44-.88,9.4,9.4,0,0,0,.68-3.54,9.56,9.56,0,0,0-1.47-5.14,22.44,22.44,0,0,0-2-2.47,6.59,6.59,0,0,1-1.56-2.82c-.47-2.19.25-4.4.1-6.44a10.78,10.78,0,0,0-1.44-5.15,8.9,8.9,0,0,0-2.44-2.65,8.57,8.57,0,0,0-.84-.51l-.31-.14a12.43,12.43,0,0,0,1,.79,9.19,9.19,0,0,1,2.27,2.68,10.71,10.71,0,0,1,1.29,5,19.75,19.75,0,0,1-.19,3.1,10.66,10.66,0,0,0,.07,3.42,7,7,0,0,0,1.66,3,23.86,23.86,0,0,1,2,2.41,9.32,9.32,0,0,1,1.5,4.91,10,10,0,0,1-.52,3.48C128.06,188.47,127.83,188.88,127.87,188.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "124.21px 173.89px"
    },
    id: "elemyyjnev8ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66,148.92a24.41,24.41,0,0,1,3.38.19,12.31,12.31,0,0,1,7,3.78,15.31,15.31,0,0,1,3.37,7.29,19.45,19.45,0,0,1,.17,3.39,3.14,3.14,0,0,0,.19-.91,10.82,10.82,0,0,0,0-2.52,14.62,14.62,0,0,0-3.35-7.56,12.1,12.1,0,0,0-7.3-3.79,10.37,10.37,0,0,0-2.53,0A3,3,0,0,0,105.66,148.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "112.752px 156.141px"
    },
    id: "el3l6bth870uy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,159.29a2.55,2.55,0,0,0,.11-.79,8,8,0,0,0-.23-2.18,9,9,0,0,0-11.25-6.62,8.07,8.07,0,0,0-2,.85c-.44.28-.66.46-.64.49a15.53,15.53,0,0,1,2.73-1,8.94,8.94,0,0,1,10.86,6.39A17.41,17.41,0,0,1,113.2,159.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "106.251px 154.32px"
    },
    id: "el1md2t1eb6ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.56,238.26s3.46,7.88,3.26,11.61-3.77,15.85-3.77,15.85l42.29,3.95.19-9.78-1.27-40.23,23.58-35.87L137,173.45,119.65,197l-4.39-1.7-19,2.4V201l-.54.06a38.9,38.9,0,0,0-11.82,4.63,19.8,19.8,0,0,0-9.06,20.07c.77,4.8,2.27,10.63,5.15,14C85.53,246.22,90.56,238.26,90.56,238.26Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "114.705px 221.56px"
    },
    id: "elhexjvxk6lj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.56,219.48S82.4,207.2,83,206.31c.74-1.05,9.63-4.87,9.76-4.48l1.95,13.5Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "88.8024px 210.641px"
    },
    id: "elmkk7i98pb2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.6 220.16 119.59 243.71 128.48 243.71 128.48 220.16 120.6 220.16",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "124.035px 231.935px"
    },
    id: "elhirgc1s7i79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.89,231.94a2.2,2.2,0,0,1,.5,0l1.53,0,5.85-.09h.17v.18c.06,5.65.09,14.1.09,23.55v.26h-9.42l0-.26c.33-6.79.63-12.69.84-17,.12-2,.21-3.67.28-4.87,0-.53.06-1,.09-1.29a1.69,1.69,0,0,1,0-.42,3.7,3.7,0,0,1,0,.48c0,.36,0,.8,0,1.34,0,1.22-.08,2.88-.14,4.94-.15,4.23-.36,10.07-.6,16.8l-.25-.26h8.89l-.26.26c0-9.45,0-17.9.09-23.55l.17.17L108,232l-1.57,0Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "109.32px 243.845px"
    },
    id: "elevl50wi7oj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.18 205.59 130.8 199.66 139.04 187.63 148.65 193.21 140.18 205.59",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "139.725px 196.61px"
    },
    id: "elwpn4siafbxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg3ce8f99664"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "117.035px 210.775px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.27,
    y: 206.31,
    width: 27.53,
    height: 8.93,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "117.035px 210.775px"
    },
    id: "el88z37z66dxc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,230.6a2.34,2.34,0,0,1,0-.82c.07-.53.16-1.29.24-2.22a41.43,41.43,0,0,0,0-7.34,40.76,40.76,0,0,0-1.34-7.22c-.5-1.81-.91-2.91-.83-2.94s.17.24.38.73a21.65,21.65,0,0,1,.81,2.1,33.66,33.66,0,0,1,1.5,7.28,32.63,32.63,0,0,1-.15,7.43,21.06,21.06,0,0,1-.41,2.21A2.58,2.58,0,0,1,130.4,230.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.882px 220.329px"
    },
    id: "elf9a5butdnnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,177.36a13.37,13.37,0,0,1-1.61,2.07c-1,1.23-2.51,2.91-4.16,4.75l-1.76,1.94-.15.17-.18-.12c-1.51-1-2.8-1.93-3.7-2.58a6.86,6.86,0,0,1-1.39-1.12,8.42,8.42,0,0,1,1.56.86c.95.58,2.28,1.42,3.81,2.42l-.32,0,1.74-2c1.65-1.84,3.16-3.47,4.27-4.64A13.87,13.87,0,0,1,143.75,177.36Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "137.275px 181.825px"
    },
    id: "elhe19j1f3yq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,185.87a17.09,17.09,0,0,1-2.77-1.28c-1.69-.85-4-2.07-6.53-3.43s-4.81-2.63-6.45-3.56a18.75,18.75,0,0,1-2.6-1.61,17.37,17.37,0,0,1,2.78,1.28c1.68.86,4,2.07,6.52,3.43s4.81,2.63,6.45,3.56A18,18,0,0,1,153.47,185.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "144.295px 180.93px"
    },
    id: "el1ct5yyi9078",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.35,431.12,53.82,451.6l-8.26,15.18a2.15,2.15,0,0,0,1,3h0a2.14,2.14,0,0,0,2-.09c3.84-2.22,17.93-10.46,18.18-12,.29-1.76,6.22-21.3,6.22-21.3Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "59.1261px 450.553px"
    },
    id: "elrw0pqtuta9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfud4o1gvap"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "56.775px 463.127px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.55,469.76,67,456.32l-.21.86A3.29,3.29,0,0,1,65.58,459c-1.67,1.2-6.34,4.43-17,10.65a2.15,2.15,0,0,1-2,.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "56.775px 463.127px"
    },
    id: "elhwo7ak75c36",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el1ugyrjo5ovb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "64.8872px 449.879px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.47,448.72a1.3,1.3,0,0,0-.75,1.57,1.24,1.24,0,0,0,1.54.75,1.37,1.37,0,0,0,.79-1.66,1.31,1.31,0,0,0-1.7-.61",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "64.8872px 449.879px"
    },
    id: "el1mdvu7qyjvv",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,462A6.4,6.4,0,0,0,52,460a6.52,6.52,0,0,0-2.24-1c0-.06.29-.15.79-.1a3.37,3.37,0,0,1,1.74.77,3.29,3.29,0,0,1,1.07,1.59C53.49,461.68,53.45,462,53.39,462Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "51.6031px 460.443px"
    },
    id: "elghxkux8tkcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.27,464.37c-.12.06-.61-.76-1.59-1.32a16.12,16.12,0,0,0-1.92-.74,2.39,2.39,0,0,1,2.16.34C51,463.3,51.39,464.34,51.27,464.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "49.5254px 463.281px"
    },
    id: "el48hokqvxem9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,459.16a23,23,0,0,0-2.32-2.2,21.86,21.86,0,0,0-2.85-1.45A5.9,5.9,0,0,1,57,459.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "54.415px 457.335px"
    },
    id: "elislxele18w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.85,453.05c-.08.11-1.09-.64-2.54-1.05s-2.7-.35-2.72-.48a4.15,4.15,0,0,1,2.85,0A4.11,4.11,0,0,1,58.85,453.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "56.22px 452.164px"
    },
    id: "el2n3qbmpaym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.34,447.07a10.53,10.53,0,0,0-2.63-1.17,10.6,10.6,0,0,0-2.87,0c0-.05.27-.25.8-.41a4.66,4.66,0,0,1,2.17-.06,4.77,4.77,0,0,1,2,.92C60.2,446.73,60.38,447,60.34,447.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "57.5927px 446.2px"
    },
    id: "eldlk16x589lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,444.77a1.63,1.63,0,0,1,.16-.77,5.48,5.48,0,0,1,1.11-1.87,2.41,2.41,0,0,1,1.3-.89.88.88,0,0,1,.9.42,1.45,1.45,0,0,1,.09,1,3,3,0,0,1-3.25,2.1,3.53,3.53,0,0,1-2.93-2.62,1.26,1.26,0,0,1,.19-1,.83.83,0,0,1,1-.22,3.05,3.05,0,0,1,1.17,1,6.25,6.25,0,0,1,1,1.93,1.78,1.78,0,0,1,.14.78,9.43,9.43,0,0,0-1.4-2.5,2.65,2.65,0,0,0-1-.87.43.43,0,0,0-.53.12.8.8,0,0,0-.08.66,3.14,3.14,0,0,0,2.56,2.24,2.63,2.63,0,0,0,2.79-1.74,1,1,0,0,0,0-.7.46.46,0,0,0-.49-.24,2.17,2.17,0,0,0-1.11.73A8.12,8.12,0,0,0,58,444.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "58.4788px 442.811px"
    },
    id: "elbre0pg0usp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljpjtnlmx54"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "65.065px 435.81px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "57.82 433.34 57.21 436.26 71.68 440.5 72.92 436.4 58.35 431.12 57.82 433.34",
    id: "ellz14vp3kzb",
    className: "animable",
    style: {
      transformOrigin: "65.065px 435.81px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124.65,438.7l-1.23,16.37s16.23,6.74,16.3,9.79l-31.83-1.23.86-25.59Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "123.805px 451.45px"
    },
    id: "el1g774euh44s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxuvyyovknl8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "113.891px 454.542px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.63,453.31a1.3,1.3,0,0,0-.95,1.45,1.25,1.25,0,0,0,1.42,1,1.37,1.37,0,0,0,1-1.54,1.31,1.31,0,0,0-1.6-.84",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "113.891px 454.542px"
    },
    id: "elhz5za9q3r6g",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elb2kb56fa8zw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "123.815px 462.955px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.89,463.63l.19-2.58,30.45,2.15s1.39.67,1.19,1.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "123.815px 462.955px"
    },
    id: "elxpuwwlt51eh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.94,454.93c0,.15-.79.19-1.57.66s-1.22,1.11-1.36,1.05.13-1,1.09-1.51S124,454.79,123.94,454.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.459px 455.715px"
    },
    id: "el6yb16xn53oq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.23,456.44c0,.15-.65.39-1.21,1s-.73,1.32-.89,1.31-.21-.9.49-1.67S127.23,456.29,127.23,456.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.13px 457.558px"
    },
    id: "elzbkcwuzunz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,460.51c-.14,0-.33-.76.1-1.59s1.18-1.15,1.24-1-.41.57-.75,1.26S129.13,460.5,129,460.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.59px 459.197px"
    },
    id: "elyh306cstsr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.81,451.17c-.07.14-.78-.11-1.66-.08s-1.57.28-1.65.14.6-.67,1.64-.68S123.89,451.05,123.81,451.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.155px 450.911px"
    },
    id: "el7kpna0k7nvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elon9c0p3cj0h"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "116.475px 442.8px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.4 441.94 124.19 444.86 108.55 444.11 108.65 440.74 124.4 441.94",
    id: "elbbqbjsvkaik",
    className: "animable",
    style: {
      transformOrigin: "116.475px 442.8px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124,447.86a3,3,0,0,1-1.6-.07,7.3,7.3,0,0,1-1.65-.58,7.58,7.58,0,0,1-.89-.52,1.8,1.8,0,0,1-.47-.39.67.67,0,0,1,0-.83.84.84,0,0,1,.7-.33,2,2,0,0,1,.59.1,5.7,5.7,0,0,1,1,.38,5.54,5.54,0,0,1,1.43,1c.71.72.94,1.31.89,1.34s-.41-.46-1.14-1.05a6.74,6.74,0,0,0-1.4-.86,6,6,0,0,0-.9-.31c-.33-.11-.62-.12-.71,0s0,.08,0,.18a1.45,1.45,0,0,0,.34.28,7.45,7.45,0,0,0,.82.52,9.21,9.21,0,0,0,1.52.65A10.7,10.7,0,0,1,124,447.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.626px 446.55px"
    },
    id: "el0260kfeiweb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.78,448.07a2.55,2.55,0,0,1-.36-1.55,5.31,5.31,0,0,1,.29-1.74,5,5,0,0,1,.44-.95,1.34,1.34,0,0,1,1-.77.75.75,0,0,1,.65.47,2.08,2.08,0,0,1,.14.59,3.86,3.86,0,0,1,0,1.08,3.75,3.75,0,0,1-.75,1.62c-.65.8-1.31,1-1.32.91s.51-.36,1-1.14a3.91,3.91,0,0,0,.56-1.48,3.15,3.15,0,0,0,0-.92c0-.34-.15-.62-.28-.59s-.43.24-.57.5a4.85,4.85,0,0,0-.43.85,5.85,5.85,0,0,0-.37,1.58C123.73,447.46,123.87,448.05,123.78,448.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.694px 445.565px"
    },
    id: "elle6lcsmn7dp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.32,229l8.23.46a41.27,41.27,0,0,0,2.33,6.75c6.63-11.51,11.77-26.92,13.05-33.12-.19-.62-.41-1.3-.68-2.07a8.71,8.71,0,0,1,.1-3.48c.23-1.38.61-3.24.73-4.1.35-2.62.77-3,1.69-2.73,1.24.4-.51,7.35.5,7.5.55.08,1.22-2.3,1.41-4.25s1.08-8,1.73-8.37c1-.59,1.77.34,1.53,2.29s-.55,7.84.49,7.92,1.87-9.89,1.87-9.89-.16-2.16,1-2.11c2.16.09.47,10.6.29,11.59-.13.69,1,.82,1.09.07s.62-10,2.82-9.89c1.68.06-1.31,8.66-.36,10.65s1.6-6.77,3.21-6.65c.6,0,1,.16-.06,5.12a111.15,111.15,0,0,1-3.85,11.63c-2.55,13.75-13.74,57.74-31.28,49.69-9.82-4.51-14.4-26.82-14.4-26.82Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "100.854px 220.393px"
    },
    id: "elm0013d3frzr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47,206.31a1.26,1.26,0,0,1,.09-.3c.07-.22.17-.51.29-.86.27-.8.66-1.91,1.15-3.32s1.09-3.21,1.69-5.29c.3-1,.55-2.16.78-3.37.11-.6.23-1.22.3-1.86a6,6,0,0,0,0-.95c0-.33-.07-.59-.33-.6s-.45.15-.63.43a5.26,5.26,0,0,0-.42.93c-.23.66-.42,1.36-.6,2.08s-.35,1.46-.57,2.21a3.4,3.4,0,0,1-.5,1.16.4.4,0,0,1-.55.07,1,1,0,0,1-.23-.32,2.56,2.56,0,0,1-.18-.64,21.27,21.27,0,0,1,.5-5c.15-.84.3-1.69.41-2.55a11.38,11.38,0,0,0,.1-1.3c0-.39,0-.93-.23-1s-.6.16-.8.52a5.18,5.18,0,0,0-.55,1.19,19.07,19.07,0,0,0-.65,2.68c-.16.93-.28,1.87-.39,2.82,0,.48-.09,1-.14,1.44l-.06.73a1.09,1.09,0,0,1-.33.84.84.84,0,0,1-1,0,.72.72,0,0,1-.31-.47.8.8,0,0,1,0-.27l0-.18c.07-.49.15-1,.22-1.47.14-1,.26-2,.36-3s.16-2,.18-3a10.14,10.14,0,0,0-.3-3,1,1,0,0,0-.42-.61.53.53,0,0,0-.57.18,2.76,2.76,0,0,0-.31,1.63v0h0c-.18,2-.4,3.91-.68,5.81-.15,1-.3,1.9-.54,2.83a6.28,6.28,0,0,1-.22.7,1.44,1.44,0,0,1-.47.72.52.52,0,0,1-.62-.13,1.16,1.16,0,0,1-.22-.38,3.5,3.5,0,0,1-.19-.72,26.67,26.67,0,0,1-.05-5.5,15.26,15.26,0,0,0,.13-2.57,1.39,1.39,0,0,0-.46-.95.51.51,0,0,0-.43-.07.82.82,0,0,0-.24.1.34.34,0,0,0-.12.14,12.2,12.2,0,0,0-.66,2.34c-.16.8-.3,1.6-.43,2.39s-.24,1.56-.34,2.33-.16,1.53-.31,2.28a11.4,11.4,0,0,1-.59,2.17,2.93,2.93,0,0,1-.24.51c-.12.16-.18.37-.5.47a.43.43,0,0,1-.43-.18,1.29,1.29,0,0,1-.13-.31,3.89,3.89,0,0,1-.07-.56c0-1.43.2-2.74.27-4a9.19,9.19,0,0,0,0-1.82c0-.27-.12-.58-.28-.65a.77.77,0,0,0-.68,0,2.42,2.42,0,0,0-.62,1.37c-.12.52-.17,1-.27,1.53-.35,2-.72,3.69-.89,5.08a6.44,6.44,0,0,0,0,1.85c.12.5.29.95.38,1.3l.24.82a.82.82,0,0,1,.07.28,1,1,0,0,1-.11-.27l-.29-.79c-.12-.36-.29-.77-.44-1.32a6.57,6.57,0,0,1,0-1.89c.15-1.42.49-3.11.81-5.1.09-.49.14-1,.26-1.55a4.88,4.88,0,0,1,.22-.81,1.44,1.44,0,0,1,.52-.77,1.08,1.08,0,0,1,1,0c.4.23.41.61.48.9a10,10,0,0,1,0,1.89c-.06,1.28-.26,2.62-.23,4a3.5,3.5,0,0,0,.06.48c0,.16.12.22.1.19s.16-.14.23-.27a4.91,4.91,0,0,0,.22-.46,12.42,12.42,0,0,0,.55-2.1c.14-.72.18-1.48.29-2.25s.2-1.56.33-2.35.26-1.6.42-2.41a11.48,11.48,0,0,1,.71-2.48.74.74,0,0,1,.29-.32,1.54,1.54,0,0,1,.35-.15,1,1,0,0,1,.8.13,1.85,1.85,0,0,1,.69,1.28,5.23,5.23,0,0,1,0,1.37c0,.43-.08.87-.11,1.31a26.79,26.79,0,0,0,0,5.37,3.74,3.74,0,0,0,.16.62.85.85,0,0,0,.13.22s0,0,0,0h0c0,.2,0,.05,0,.08s0,0,0-.07a1.64,1.64,0,0,0,.24-.46c.07-.21.14-.43.2-.65.22-.89.38-1.83.52-2.77.28-1.89.49-3.82.67-5.78v0a3.25,3.25,0,0,1,.42-2,1,1,0,0,1,1.17-.34,1.43,1.43,0,0,1,.72.92,10.41,10.41,0,0,1,.33,3.16c0,1-.09,2.06-.19,3.08s-.22,2-.36,3c-.07.5-.15,1-.22,1.48-.07.32,0,.33,0,.42a.37.37,0,0,0,.39,0c.11-.07.12-.22.14-.49l.07-.73c0-.48.1-1,.14-1.44.11-1,.24-1.92.4-2.85a19.83,19.83,0,0,1,.67-2.76,5.92,5.92,0,0,1,.61-1.3,2,2,0,0,1,.54-.56.8.8,0,0,1,1.33.62,4.31,4.31,0,0,1,.05.71,11.88,11.88,0,0,1-.12,1.35c-.11.88-.27,1.73-.42,2.57a20.91,20.91,0,0,0-.52,4.86,1.59,1.59,0,0,0,.14.51.75.75,0,0,0,.1.17s0,0,0,0,0,0,0,0,0,0,0-.05a3.35,3.35,0,0,0,.41-1c.22-.73.39-1.47.58-2.19s.38-1.43.63-2.11a5.63,5.63,0,0,1,.46-1,1.44,1.44,0,0,1,.38-.44.77.77,0,0,1,.3-.15.85.85,0,0,1,.32,0,.64.64,0,0,1,.53.39,1.63,1.63,0,0,1,.11.55,5.54,5.54,0,0,1-.06,1c-.07.66-.2,1.28-.32,1.89a32.15,32.15,0,0,1-.83,3.38c-.62,2.08-1.25,3.84-1.77,5.27s-1,2.55-1.24,3.29c-.14.35-.26.63-.34.85S121.48,206.32,121.47,206.31Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "116.517px 194.881px"
    },
    id: "elxumxi9tlt5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,230c1.59,5.62,4.7,14.3,8,23.46a1.59,1.59,0,0,0,2.93.14l8.2-17.35s-2-14.25-1.81-13.75-16.92,1.85-16.92,1.85Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "85.265px 238.497px"
    },
    id: "ely2601oqifl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.88,231.33s-.22-.17-.63-.28a1.56,1.56,0,0,0-1.59.42l-.21.24-.13-.31c-.44-1.12-1-2.57-1.56-4.17a49.65,49.65,0,0,1-2.15-6.75,46.76,46.76,0,0,1,2.64,6.58c.58,1.59,1.08,3.06,1.45,4.2l-.34-.06a1.72,1.72,0,0,1,1.09-.51,1.81,1.81,0,0,1,.88.14C97.78,231,97.9,231.31,97.88,231.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.746px 226.095px"
    },
    id: "elcuj8yxix6qq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.25,247.83a13.28,13.28,0,0,1,1.19-2.46c.79-1.48,1.91-3.52,3.19-5.75s2.45-4.24,3.32-5.68a14.47,14.47,0,0,1,1.51-2.28,14.29,14.29,0,0,1-1.19,2.46c-.79,1.49-1.92,3.52-3.19,5.76s-2.45,4.24-3.32,5.68A14.87,14.87,0,0,1,86.25,247.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "90.855px 239.745px"
    },
    id: "elxsg4sb6z1m8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.79,245.22a9.28,9.28,0,0,1,1.43-1c.93-.6,2.28-1.44,3.92-2.44l-.09.27c-.91-2.13-2-4.62-3.12-7.3-1.42-3.37-2.69-6.47-3.62-8.78l.28.09c-1.3.71-2.36,1.27-3.09,1.65a5.94,5.94,0,0,1-1.18.54,5.63,5.63,0,0,1,1.07-.73c.71-.44,1.73-1.05,3-1.79l.18-.11.09.2c1,2.28,2.32,5.35,3.74,8.73,1.12,2.69,2.15,5.19,3,7.33l.07.18-.16.09c-1.66,1-3,1.75-4,2.28A8.52,8.52,0,0,1,80.79,245.22Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "80.895px 235.42px"
    },
    id: "ele2fm8aqc8j5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28,442.82a5.87,5.87,0,0,0,5.69-5.51c1.71-27.68,9.41-153.59,7.87-157.54-1.74-4.44-6.31-19.88-6.31-19.88L91.7,258S81.54,274,80.08,280.18C78.76,285.69,41.77,402.25,37.17,427a5.07,5.07,0,0,0,3.53,5.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.0638px 350.41px"
    },
    id: "eltbg2117flo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.76,258.87s-.05.15-.18.44L99,260.57l-2.28,4.82c-.45,1.07-.94,2.26-1.49,3.55s-1.15,2.71-1.69,4.26-1.2,3.19-1.81,4.95-1.18,3.64-1.82,5.61L88.1,290c-.59,2.18-1.15,4.46-1.77,6.82s-1.11,4.82-1.7,7.35S83.51,309.31,83,312c-1.1,5.36-2.18,11-3.32,16.86s-2.36,11.9-3.79,18.06C75.2,350,74.4,353,73.66,356s-1.61,5.9-2.49,8.75c-1.73,5.71-3.63,11.15-5.57,16.27-3.92,10.25-8,19.26-11.5,26.75s-6.57,13.47-8.67,17.6L43,430.14c-.27.52-.49.93-.65,1.22a3.72,3.72,0,0,1-.23.41,3.72,3.72,0,0,1,.19-.43c.14-.3.34-.72.6-1.25.55-1.12,1.34-2.73,2.36-4.79,2-4.15,5-10.16,8.51-17.67s7.5-16.52,11.39-26.76c1.92-5.12,3.81-10.55,5.54-16.25.87-2.84,1.65-5.77,2.47-8.73s1.54-6,2.21-9.09c1.43-6.15,2.63-12.21,3.8-18.05s2.23-11.49,3.35-16.85c.53-2.69,1.13-5.3,1.67-7.83s1.17-5,1.72-7.36,1.2-4.64,1.8-6.82,1.26-4.25,1.85-6.24L91.42,278c.62-1.76,1.27-3.4,1.85-4.94s1.17-3,1.74-4.25,1.07-2.48,1.53-3.54c1-2.09,1.82-3.7,2.36-4.79l.63-1.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "70.94px 345.32px"
    },
    id: "eljlt5y9u211r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,435.24s0-.15.1-.45.21-.77.36-1.33l1.42-5.1c1.23-4.46,3-10.86,5.2-18.76s4.73-17.37,7.48-27.88c1.36-5.26,2.78-10.78,4.26-16.5s2.91-11.68,4.43-17.76,2.9-12,4.29-17.8,2.63-11.31,3.87-16.6c2.41-10.59,4.53-20.15,6.26-28.18s3.1-14.52,4.07-19c.47-2.23.84-4,1.1-5.18.13-.57.23-1,.3-1.34s.12-.46.12-.46a4.14,4.14,0,0,1-.07.47c-.06.32-.14.77-.25,1.35-.23,1.21-.57,3-1,5.2L104,274.1c-.67,3.2-1.42,6.84-2.26,10.86-1.68,8-3.76,17.6-6.16,28.21-1.21,5.29-2.47,10.86-3.84,16.61s-2.81,11.71-4.27,17.81-3,12-4.45,17.75-2.91,11.25-4.28,16.5c-2.79,10.51-5.37,20-7.59,27.86l-3,10.67c-.91,3.13-1.7,5.83-2.34,8s-1.16,3.89-1.51,5.08c-.17.56-.31,1-.4,1.31S63.71,435.24,63.71,435.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "85.34px 347.07px"
    },
    id: "elg0sykca3hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,259s0,.15.07.46l.17,1.38c.07.61.16,1.36.26,2.23s.13,1.92.2,3.07c0,.58.07,1.19.1,1.83s0,1.32,0,2v2.2c0,.76-.07,1.56-.1,2.38s-.08,1.67-.13,2.54-.16,1.78-.25,2.71c-.13,1.86-.45,3.8-.7,5.86-.62,4.09-1.44,8.54-2.49,13.29s-2.28,9.79-3.56,15.1-2.61,10.89-3.71,16.72-2,11.91-2.82,18.16S98,361.27,97.3,367.18s-1.3,11.61-2,17l-1.08,7.92c-.42,2.55-.79,5-1.21,7.44s-.85,4.7-1.32,6.91-.94,4.32-1.41,6.33-1,3.91-1.5,5.71-1.06,3.46-1.54,5c-.25.78-.47,1.54-.73,2.26s-.52,1.41-.76,2.07c-.49,1.31-.94,2.52-1.35,3.6-.88,2.14-1.65,3.76-2.13,4.88l-.58,1.26c-.13.28-.21.42-.21.42s0-.16.16-.45.31-.73.53-1.28c.46-1.12,1.19-2.76,2-4.9l1.29-3.62.75-2.06c.25-.72.46-1.49.7-2.27.47-1.57,1-3.24,1.5-5l1.46-5.7,1.38-6.33c.45-2.21.84-4.52,1.29-6.91s.77-4.88,1.17-7.43.7-5.2,1.06-7.91c.67-5.42,1.32-11.11,2-17s1.31-12,2.11-18.29,1.74-12.35,2.84-18.2,2.45-11.43,3.74-16.73,2.55-10.35,3.61-15.08,1.9-9.18,2.55-13.26c.26-2,.59-4,.73-5.84.1-.92.18-1.82.27-2.69s.1-1.72.15-2.54.11-1.6.12-2.37,0-1.49,0-2.19,0-1.37,0-2-.06-1.24-.08-1.82c-.06-1.15-.06-2.18-.15-3.06s-.15-1.63-.21-2.24-.09-1.05-.12-1.38A3.32,3.32,0,0,1,112.37,259Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "97.3317px 348.49px"
    },
    id: "elf6k0tw4hr3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.91,441.63a4.07,4.07,0,0,1-.11-.46c-.06-.33-.15-.78-.26-1.36s-.24-1.35-.4-2.23-.37-1.88-.47-3-.28-2.43-.45-3.83-.2-2.94-.32-4.58c0-.82-.1-1.68-.13-2.55s0-1.79,0-2.73,0-1.89,0-2.88.08-2,.11-3,.09-2.1.13-3.18.18-2.19.26-3.32c.15-2.26.44-4.59.72-7s.68-4.91,1-7.48.84-5.2,1.36-7.89c2-10.79,4.7-22.52,7.2-34.9a350.49,350.49,0,0,0,5.25-35.21c1.08-10.9,1.49-20.75,1.63-29,0-4.14,0-7.89,0-11.17s-.14-6.12-.24-8.44-.19-4.11-.24-5.33c0-.59,0-1.05,0-1.38s0-.48,0-.48,0,.16,0,.47.06.8.11,1.39c.08,1.21.23,3,.33,5.32s.24,5.15.33,8.44.12,7,.1,11.18c-.09,8.29-.47,18.16-1.52,29.07a345.39,345.39,0,0,1-5.22,35.27c-2.5,12.4-5.25,24.12-7.24,34.89-.52,2.68-.93,5.32-1.38,7.87s-.79,5.05-1.05,7.47-.59,4.74-.74,7c-.1,1.12-.19,2.22-.28,3.3s-.1,2.14-.15,3.17-.08,2.05-.13,3v5.59c0,.87.08,1.72.12,2.54.1,1.64.1,3.18.27,4.57s.28,2.68.4,3.84.29,2.16.42,3l.36,2.23c.09.58.15,1,.21,1.37S107.91,441.63,107.91,441.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "114.791px 350.93px"
    },
    id: "elku2pbf0mdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32,259.79s.05.15.14.45l.39,1.32.61,2.17a30.23,30.23,0,0,1,.7,3c.22,1.13.53,2.38.75,3.77s.41,2.9.64,4.53.27,3.38.42,5.24.15,3.82.11,5.89c0,4.13-.34,8.64-.87,13.47s-1.36,9.95-2.32,15.31l-3.14,16.82c-1.1,5.83-2.06,11.89-2.93,18.12s-1.58,12.32-2.16,18.22-1,11.61-1.34,17.05-.55,10.61-.65,15.46-.16,9.36-.14,13.48.08,7.85.18,11.12.22,6.09.31,8.39.2,4.07.26,5.3q0,.89.06,1.38c0,.32,0,.48,0,.48s0-.16-.06-.47l-.11-1.38c-.08-1.21-.22-3-.35-5.3s-.3-5.12-.4-8.39-.21-7-.26-11.13,0-8.64.08-13.49.31-10,.6-15.48.72-11.16,1.31-17.07,1.27-12,2.16-18.25,1.83-12.3,2.94-18.13l3.17-16.81c1-5.36,1.77-10.48,2.36-15.28s.87-9.31.93-13.43c0-2.06-.06-4-.07-5.87s-.26-3.59-.38-5.22-.41-3.13-.59-4.52-.5-2.63-.7-3.77-.41-2.13-.66-3-.41-1.57-.56-2.17-.26-1-.34-1.34S130.32,259.79,130.32,259.79Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "127.121px 350.275px"
    },
    id: "elk7lwgbwr3i",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-14",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "378.81px 221.336px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elrjb6e8qx9h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 111.84,
    width: 114.62,
    height: 108.71,
    rx: 6.79,
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "378.81px 166.195px",
      transform: "rotate(-8.04deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.11,179.71a4.46,4.46,0,0,1-.76.16l-2.19.36L389,181.48l-27.29,4-.22,0-.06-.22c-.41-1.42-.85-2.91-1.29-4.43-3.71-13-7-24.57-9.19-32.14l.18.11-7.28,1-1.94.24a4.35,4.35,0,0,1-.68,0,3.83,3.83,0,0,1,.66-.14l1.93-.32,7.26-1.12.14,0,0,.13,9.38,32.09,1.28,4.44-.28-.19L389,181.13l8.14-1.09,2.21-.27A4.84,4.84,0,0,1,400.11,179.71Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "370.67px 166.97px"
    },
    id: "elx828ud56ev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.46,177.43l.19,0,.56-.11,2.19-.35,8.21-1.26,28.32-4.16-.22.24c.16-4.89.33-10.18.5-15.65.09-2.81.18-5.58.27-8.22l.29.27-33.41,4.71-9.89,1.34-2.67.34-.7.08h-.24a.81.81,0,0,1,.24-.06l.68-.12,2.66-.43,9.88-1.5,33.38-4.88.3,0v.31c-.08,2.64-.17,5.4-.26,8.22-.18,5.47-.36,10.76-.52,15.65V172l-.21,0-28.35,4-8.22,1.11-2.2.28-.57.06Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "376.43px 162.56px"
    },
    id: "elyy4ttgnjdh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,194.27c-.05,0-.1-.34-.35-.88a3.86,3.86,0,0,0-1.69-1.79,3.67,3.67,0,0,0-5.38,3.74,3.66,3.66,0,0,0,2.84,3,3.71,3.71,0,0,0,3.37-1,3.81,3.81,0,0,0,1.12-2.2c.09-.59,0-.94.09-.94a2,2,0,0,1,.12,1,3.88,3.88,0,0,1-1.07,2.44,4.06,4.06,0,0,1-3.73,1.18,4.1,4.1,0,0,1-1.1-7.66,4.07,4.07,0,0,1,3.91.08,3.88,3.88,0,0,1,1.71,2A2.08,2.08,0,0,1,372.81,194.27Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "368.885px 194.798px"
    },
    id: "elc80h8c70416",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.52,190.72s-.1-.34-.35-.88a3.83,3.83,0,0,0-1.7-1.79,3.65,3.65,0,1,0,.84,5.81,3.81,3.81,0,0,0,1.12-2.2c.09-.59,0-.94.09-.94a2,2,0,0,1,.11,1,3.82,3.82,0,0,1-1.06,2.44,4.06,4.06,0,0,1-3.73,1.18,4.1,4.1,0,0,1-1.1-7.66,4.07,4.07,0,0,1,3.91.08,3.88,3.88,0,0,1,1.71,2A2.08,2.08,0,0,1,397.52,190.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "393.591px 191.318px"
    },
    id: "el5rfopwxqplf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljcp6s1pmrqh"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 397.08,
    cy: 144.31,
    r: 11.07,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "397.08px 144.31px",
      transform: "rotate(-56.52deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.44,139.36a10.72,10.72,0,0,1-1.17,2c-.78,1.18-1.88,2.78-3.12,4.54l-1.33,1.87-.14.2-.2-.13a35.43,35.43,0,0,1-4.48-3.19,36.39,36.39,0,0,1,4.75,2.77l-.34.06,1.32-1.88c1.24-1.76,2.39-3.33,3.24-4.46A10.14,10.14,0,0,1,402.44,139.36Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "397.22px 143.665px"
    },
    id: "elwxw4b73tlie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el678os3klmu9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.61,
    y: 240.23,
    width: 92.86,
    height: 88.07,
    rx: 6.79,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "381.04px 284.265px",
      transform: "rotate(14.15deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,272.12l.7,19.1,35,8.83L406,284.37s-3.39-2.1-5.86-2.19l4.12-19.1a2.69,2.69,0,0,0-3.07-3.22l-3.77.63-19.75-5-2-1.71a2.64,2.64,0,0,0-4.3,1.38L366.75,274A15.35,15.35,0,0,0,360.41,272.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "383.205px 276.591px"
    },
    id: "eldqyq18x8wnd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,284.44a13.94,13.94,0,0,0,6.34,6,21.51,21.51,0,0,0,8.58,2c1.61.06,3.4-.08,4.53-1.22s1.27-3,1.3-4.68a22.57,22.57,0,0,0-.52-6.36,7.65,7.65,0,0,0-3.73-5c-2.6-1.26-5.75-.37-8.26,1.05a21.63,21.63,0,0,0-8,7.89",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "380.545px 283.514px"
    },
    id: "el4ogx54d0p6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9jdzqrpq9im"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 291.19,
    width: 1.91,
    height: 16.7,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "359.955px 299.54px",
      transform: "rotate(14.15deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elackl15yxag9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.49,
    y: 292.95,
    width: 1.91,
    height: 8.53,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "367.445px 297.215px",
      transform: "rotate(14.15deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwm7z6foudnb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.06,
    y: 297.63,
    width: 1.91,
    height: 8.53,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.015px 301.895px",
      transform: "rotate(14.15deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxo1x563fef"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.24,
    y: 299.57,
    width: 1.91,
    height: 16.7,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.195px 307.92px",
      transform: "rotate(14.15deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,282.78c-.14,0,1.28-6.13,3.17-13.61s3.52-13.52,3.66-13.48-1.27,6.12-3.16,13.61S371.22,282.81,371.08,282.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "374.495px 269.235px"
    },
    id: "elspsg9vjzig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,287.77c-.14,0,1.27-6.13,3.16-13.61s3.53-13.52,3.67-13.49-1.28,6.13-3.17,13.61S391,287.8,390.87,287.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.285px 274.22px"
    },
    id: "elfpq6ssrdro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.1,282.18a5.41,5.41,0,0,1-1,0h-.52l-.63.07-.72.09-.79.21A7.3,7.3,0,0,0,393,284.7a9.09,9.09,0,0,0-2.21,4.7l0,.27-.25-.07-9.37-2.33-10.49-2.68-.22,0,0-.22a9.86,9.86,0,0,0-.09-4.82,10.45,10.45,0,0,0-1.61-3.4,14.16,14.16,0,0,0-2.3-2.4,3.82,3.82,0,0,1,.75.47,9.36,9.36,0,0,1,1.77,1.77,10.36,10.36,0,0,1,1.75,3.46,10.11,10.11,0,0,1,.18,5l-.17-.27,10.51,2.61,9.35,2.39-.29.2a9.36,9.36,0,0,1,2.39-4.92,7.56,7.56,0,0,1,3.68-2.12l.83-.18.74-.05.64-.05.54,0A4,4,0,0,1,400.1,282.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.28px 281.71px"
    },
    id: "el4qsrkacvi27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,284.39c0,.08-.71,0-1.79.24a8.43,8.43,0,0,0-6.36,5.13c-.42,1-.52,1.71-.61,1.69a3.68,3.68,0,0,1,.27-1.82,7.87,7.87,0,0,1,2.53-3.66,8,8,0,0,1,4.12-1.71A3.61,3.61,0,0,1,370.28,284.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "365.89px 287.823px"
    },
    id: "elcjbuje4bz3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.69,300.33c-.08,0,.09-.77.09-2a10.38,10.38,0,0,0-1.07-4.57,10.24,10.24,0,0,0-3-3.59c-1-.73-1.68-1-1.65-1.12a4.5,4.5,0,0,1,1.86.82,9.32,9.32,0,0,1,4.25,8.47A4.48,4.48,0,0,1,395.69,300.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.125px 294.69px"
    },
    id: "el3b7ixrpo4g9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14",
    className: "animable",
    style: {
      transformOrigin: "258.55px 279.675px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.67,465.1l-125.83-.58A27.41,27.41,0,0,1,167.56,437l1.33-315.46a27.42,27.42,0,0,1,27.54-27.29l125.83.58a27.4,27.4,0,0,1,27.28,27.52L348.21,437.8A27.42,27.42,0,0,1,320.67,465.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "258.55px 279.675px"
    },
    id: "ele952b1e9b6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,103.68l-24.4-.12a6.07,6.07,0,0,0-5.95,6.17l0,4.42a6.06,6.06,0,0,1-5.95,6.17l-47.55-.22a6.07,6.07,0,0,1-5.9-6.22l0-4.43a6.07,6.07,0,0,0-5.9-6.22l-8.58,0-21.35-.09a19.2,19.2,0,0,0-19.29,19.11l-1.3,307.91A19.2,19.2,0,0,0,194,449.4l125.58.58a19.19,19.19,0,0,0,19.28-19.11L340.15,123A19.19,19.19,0,0,0,321,103.68Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "257.49px 276.56px"
    },
    id: "elks1y87cfle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,136.41a.52.52,0,0,1-.36-.16l-1.91-2a.46.46,0,0,1-.14-.35.49.49,0,0,1,.15-.35l1.92-1.83a.49.49,0,0,1,.7,0,.5.5,0,0,1,0,.71l-1.56,1.48,1.57,1.64a.5.5,0,0,1,0,.71A.52.52,0,0,1,192.44,136.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.494px 133.991px"
    },
    id: "elsry1x0j0oas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.08,
    y: 396.62,
    width: 136.06,
    height: 35.13,
    rx: 16.12,
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "259.11px 414.185px"
    },
    id: "elc955u6ejw0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.93,410.11h3.16a3.89,3.89,0,1,1,0,7.77h-3.16Zm3.12,7.06a3.18,3.18,0,1,0,0-6.35h-2.3v6.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "246.554px 413.995px"
    },
    id: "el7itsev5ing3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4,414a4.08,4.08,0,1,1,4.09,3.95A3.9,3.9,0,0,1,251.4,414Zm7.34,0a3.27,3.27,0,1,0-3.25,3.22A3.14,3.14,0,0,0,258.74,414Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "255.478px 413.872px"
    },
    id: "el5x77p3yte69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.88,410.11v7.77h-.67l-5-6.3v6.3h-.83v-7.77h.68l5,6.3v-6.3Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "264.63px 413.995px"
    },
    id: "elh06w4zkbe8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,417.17v.71h-5.49v-7.77h5.32v.71h-4.5v2.76h4v.7h-4v2.89Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "273.155px 413.995px"
    },
    id: "el2zkvb3lc5bl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.49,263.81h-4.23v-2h10.82v2h-4.23v10.75h-2.36Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "212.67px 268.185px"
    },
    id: "elzc01fi4a5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21,269v5.58h-2.27v-5.28c0-1.73-.86-2.57-2.31-2.57-1.62,0-2.72,1-2.72,2.93v4.92h-2.27V261.05h2.27V266a4.35,4.35,0,0,1,3.24-1.24C227.48,264.72,229.21,266.05,229.21,269Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "224.425px 267.815px"
    },
    id: "elv17d72sawdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.24,268.86v5.7H238.1v-1.19a3.45,3.45,0,0,1-3.06,1.31c-2.22,0-3.63-1.22-3.63-2.91s1.1-2.89,4.05-2.89H238v-.15c0-1.33-.8-2.11-2.42-2.11a4.8,4.8,0,0,0-3,1l-.89-1.65a6.81,6.81,0,0,1,4.11-1.21C238.62,264.72,240.24,266.05,240.24,268.86ZM238,271.51v-1.12h-2.35c-1.55,0-2,.58-2,1.29s.7,1.35,1.86,1.35A2.47,2.47,0,0,0,238,271.51Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "235.825px 269.727px"
    },
    id: "el51km0gv7oyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,269v5.58h-2.28v-5.28c0-1.73-.85-2.57-2.31-2.57-1.62,0-2.71,1-2.71,2.93v4.92h-2.28v-9.73h2.17v1.26a4.24,4.24,0,0,1,3.35-1.37C251,264.72,252.73,266.05,252.73,269Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "247.94px 269.657px"
    },
    id: "elfll87e3ef9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.59,270.39,257.9,272v2.57h-2.28V261.05h2.28v8.15l4.71-4.37h2.73l-4.06,4.08,4.44,5.65H263Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "260.67px 267.81px"
    },
    id: "el1p7q4oi9wnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,264.83l-4.55,10.51c-.89,2.2-2.13,2.87-3.75,2.87a4,4,0,0,1-2.6-.89l.91-1.67a2.43,2.43,0,0,0,1.67.67c.8,0,1.28-.38,1.71-1.35l.17-.38-4.24-9.76H273l3.06,7.19,3.08-7.19Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "275.87px 271.52px"
    },
    id: "elcoyuenuaozi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66,269.69a5.18,5.18,0,1,1,5.17,5A4.9,4.9,0,0,1,281.66,269.69Zm8.07,0a2.89,2.89,0,1,0-2.9,3A2.84,2.84,0,0,0,289.73,269.69Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "286.837px 269.514px"
    },
    id: "el1hbglxy189e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.62,264.83v9.73h-2.17v-1.24a4,4,0,0,1-3.13,1.36c-2.5,0-4.19-1.36-4.19-4.29v-5.56h2.28v5.25c0,1.76.83,2.6,2.27,2.6s2.66-1,2.66-2.93v-4.92Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "298.875px 269.756px"
    },
    id: "el73x55vl2c4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,273.26a1.41,1.41,0,0,1,1.47-1.4,1.41,1.41,0,1,1,0,2.82A1.42,1.42,0,0,1,306.18,273.26Zm.13-11.45H309l-.45,8.52h-1.81Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "307.62px 268.245px"
    },
    id: "el0xdgfk9id34",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.02,
    cy: 216.56,
    r: 26.18,
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "260.02px 216.56px"
    },
    id: "elpcyeld6uqso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,205.51c.33.27-4.56,6.85-10.92,14.69l-3.86,4.68-.53.64-.56-.58c-5-5.13-8.37-8.93-8.13-9.17s4.05,3.15,9.17,8.12L257,224l3.78-4.73C267.14,211.38,272.57,205.24,272.91,205.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "260.912px 215.511px"
    },
    id: "elew5t3d4z7wd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.21,206c-.78-2.75-4.35-2.48-4.35-2.48l.09,1.91c2.07-.36,3.35,2.06,3.35,2.06Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "295.035px 205.501px"
    },
    id: "elcro30m32gf4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,211.78c-.77-2.75-4.35-2.49-4.35-2.49l.1,1.92c2.07-.36,3.35,2.06,3.35,2.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "219.195px 211.277px"
    },
    id: "eloibo1hdrl1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.14,173.73c4.15,1.26,6.73-3.52,6.73-3.52l-2.52-1.44c-1.24,2.93-5.38,2.59-5.38,2.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.92px 171.356px"
    },
    id: "elpkb9p5joap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,178.88c-1.93.21-2.16,2.63-2.16,2.63l1.29.15c0-1.42,1.77-2,1.77-2Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "239.5px 180.27px"
    },
    id: "el0k0fo61y5w07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,196.6c.28-1.92-2-2.75-2-2.75l-.47,1.21c1.38.35,1.51,2.21,1.51,2.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "318.447px 195.56px"
    },
    id: "elfyfj7v7zxev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,153.61c.28-1.92-2-2.75-2-2.75l-.47,1.22c1.38.35,1.51,2.2,1.51,2.2Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "250.167px 152.57px"
    },
    id: "elm0fc3iekruh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.71,184.58c-.34,3,3.64,3.74,3.64,3.74l.72-2c-2.39-.22-2.73-3-2.73-3Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "205.88px 185.82px"
    },
    id: "eli5nojzp6h0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.47,173.67c1.94.11,2.56-2.24,2.56-2.24l-1.25-.36c-.23,1.4-2.07,1.69-2.07,1.69Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "293.37px 172.372px"
    },
    id: "elu9ucev0jnti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.06,181.57a4.49,4.49,0,0,1-1.6.15,4.44,4.44,0,0,1-1.6-.15,8.08,8.08,0,0,1,3.2,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "301.46px 181.574px"
    },
    id: "elu2el32dbe7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.76,177.22a8.82,8.82,0,0,1,0,3.24,8.28,8.28,0,0,1,0-3.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "304.755px 178.84px"
    },
    id: "elc5uhvof5i94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,181.46a4.49,4.49,0,0,1,1.6-.15,4.44,4.44,0,0,1,1.6.15,8.08,8.08,0,0,1-3.2,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "308.16px 181.456px"
    },
    id: "elrlxi427m9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,185.82a8.33,8.33,0,0,1,0-3.25,8.88,8.88,0,0,1,0,3.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "304.865px 184.195px"
    },
    id: "elgk8kx3zng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,184c-.06.05-.37-.21-.69-.58s-.51-.73-.45-.78.38.2.69.58S307.52,183.89,307.45,184Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "306.881px 183.32px"
    },
    id: "elq4ve3t3vd1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,179c.06.07-.15.38-.48.71s-.64.55-.7.49.15-.38.48-.71S307.24,179,307.3,179Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "306.71px 179.605px"
    },
    id: "eli5yyl6oflag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.64,180.27c-.06.07-.36-.09-.67-.35s-.51-.52-.46-.58.35.09.66.34S303.69,180.21,303.64,180.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "303.075px 179.807px"
    },
    id: "el48gavi1rya9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.49,182.45c.07.05-.12.36-.42.69s-.59.54-.65.48.12-.37.42-.69S303.43,182.39,303.49,182.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "302.956px 183.035px"
    },
    id: "elav5mxg3x1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.94,172.65a8.08,8.08,0,0,1-3.2,0,4.49,4.49,0,0,1,1.6-.15A4.44,4.44,0,0,1,215.94,172.65Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "214.34px 172.646px"
    },
    id: "elllcaf4usubi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64,168.3a8.33,8.33,0,0,1,0,3.25,8.33,8.33,0,0,1,0-3.25Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "217.64px 169.925px"
    },
    id: "el7nq8f18gvkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.45,172.55a8.08,8.08,0,0,1,3.2,0,8.08,8.08,0,0,1-3.2,0Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "221.05px 172.55px"
    },
    id: "el1u9w7b8eis8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.75,176.9a8.28,8.28,0,0,1,0-3.24,8.28,8.28,0,0,1,0,3.24Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "217.75px 175.28px"
    },
    id: "ele4vai4j4xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.34,175c-.07.06-.38-.2-.69-.58s-.52-.72-.45-.78.37.21.69.58S220.4,175,220.34,175Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "219.769px 174.32px"
    },
    id: "el7v7xv5f9c9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.19,170.1c.06.06-.16.38-.48.71s-.64.54-.7.48.15-.37.48-.7S220.13,170,220.19,170.1Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "219.6px 170.689px"
    },
    id: "elwwfngu2zzis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,171.36c-.05.06-.35-.09-.66-.35s-.52-.52-.46-.59.35.09.66.35S216.58,171.29,216.52,171.36Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "215.96px 170.888px"
    },
    id: "el29x3i6e9s1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.38,173.53c.06.06-.13.37-.42.7s-.59.54-.66.48.13-.37.42-.69S216.31,173.47,216.38,173.53Z",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "215.839px 174.12px"
    },
    id: "eluwv8xqtknbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,131.05a49,49,0,0,1-7.07.26,48.75,48.75,0,0,1-7.06-.26,47.1,47.1,0,0,1,7.06-.26A47.29,47.29,0,0,1,326.62,131.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "319.555px 131.048px"
    },
    id: "el75chkdewk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,134a47.29,47.29,0,0,1-7.07.26,47.1,47.1,0,0,1-7.06-.26,48.75,48.75,0,0,1,7.06-.26A49,49,0,0,1,326.62,134Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "319.555px 134.002px"
    },
    id: "el993c0tjy2rq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,136.93a47.29,47.29,0,0,1-7.07.26,47.1,47.1,0,0,1-7.06-.26,48.75,48.75,0,0,1,7.06-.26A49,49,0,0,1,326.62,136.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "319.555px 136.932px"
    },
    id: "el0duyjqmdcmm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb4k8q0yiwm7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.12,
    y: 337.26,
    width: 32.93,
    height: 41.57,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "260.585px 358.045px",
      transform: "rotate(-179.55deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "264.34 338.61 263.75 378.85 258.55 378.81 259.67 338.57 264.34 338.61",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "261.445px 358.71px"
    },
    id: "el1o44q5kchi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.38 338.3 244.27 338.45 277.2 338.71 244.24 343.04 243.96 378.7 225.07 378.55 225.38 338.3",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "251.135px 358.5px"
    },
    id: "elqbwos84p2pm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.67 338.38 234.92 378.63 229.31 378.58 230.23 338.34 235.67 338.38",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "232.49px 358.485px"
    },
    id: "el48xoabglws4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.62,326.13c0,.26-.55.52-1.56.77a25.9,25.9,0,0,1-7.47.54c-.56,0-1.14-.1-1.75-.19a14.21,14.21,0,0,1-1.92-.41,5.83,5.83,0,0,1-1.19-.51,3.82,3.82,0,0,1-1.25-1.18,3.51,3.51,0,0,1-.54-1.81,6,6,0,0,1,.16-1.4,24.33,24.33,0,0,1,1.26-4.17,11.23,11.23,0,0,1,1.21-2.12,9,9,0,0,1,.81-1,6.19,6.19,0,0,1,1.1-.89,4.44,4.44,0,0,1,1.49-.6,3.94,3.94,0,0,1,1.71.05,5.56,5.56,0,0,1,2.25,1.24,18.48,18.48,0,0,1,4.33,5.31,13,13,0,0,1,1.45,4.33c.13,1.08,0,1.69-.24,1.74-.53.13-1.3-2-3.4-4.66a21.43,21.43,0,0,0-4.23-4,2.48,2.48,0,0,0-1-.49.36.36,0,0,0-.18,0,1.32,1.32,0,0,0-.28.15,3.27,3.27,0,0,0-.42.37c-.15.17-.32.38-.47.59a8.16,8.16,0,0,0-.79,1.44,28,28,0,0,0-1.13,3.53,2.5,2.5,0,0,0-.1.52v0h0l-.1,0c-.12,0-.15.06-.07,0l.12-.09a0,0,0,0,0,0,0,.36.36,0,0,0,.09.09,2.5,2.5,0,0,0,.47.24,13,13,0,0,0,1.47.44c.51.14,1,.25,1.51.35,1,.2,1.93.34,2.8.46,1.75.23,3.21.39,4.22.58S250.61,325.88,250.62,326.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "242.851px 320.299px"
    },
    id: "elr2oge8xeaaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94,326.43c-.09-.52,2.37-1.29,6.21-2.42a52.82,52.82,0,0,0,6.48-2.32,6.57,6.57,0,0,0,1.41-.78c.15-.13.22-.24.2-.23s0,.15-.05.08a4,4,0,0,0-.23-.58l-.48-1a16,16,0,0,0-1-1.79,7.42,7.42,0,0,0-1.17-1.4,6.38,6.38,0,0,0-.66-.53,2.94,2.94,0,0,0-.6-.32,1.49,1.49,0,0,0-1-.09,3.18,3.18,0,0,0-1.16.67,25.28,25.28,0,0,0-4.5,4.89c-2.21,3.14-2.79,5.59-3.34,5.51-.24,0-.42-.7-.33-1.91a13.74,13.74,0,0,1,1.42-4.9,21.57,21.57,0,0,1,4.51-6.14,6.49,6.49,0,0,1,2.34-1.47,5,5,0,0,1,3.26,0,6.73,6.73,0,0,1,1.37.68,8.29,8.29,0,0,1,1.11.84,10.49,10.49,0,0,1,1.8,2.1,17.22,17.22,0,0,1,1.23,2.23l.48,1.06a5.92,5.92,0,0,1,.49,1.51,3.4,3.4,0,0,1-.37,2.18,4.08,4.08,0,0,1-1.22,1.35,9.19,9.19,0,0,1-2.25,1.12,33.94,33.94,0,0,1-7.21,1.73C252.56,327.06,250,326.91,249.94,326.43Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "258.736px 319.143px"
    },
    id: "elushu4exig7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw2iz04ue0q9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.44,
    y: 324.69,
    width: 48.4,
    height: 13.76,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "243.64px 331.57px",
      transform: "rotate(-179.55deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6xsqckmawxr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.24,
    y: 324.81,
    width: 43.75,
    height: 13.76,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "259.115px 331.69px",
      transform: "rotate(-179.55deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "267.62 324.87 267.31 338.69 262.21 338.59 262.57 324.83 267.62 324.87",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "264.915px 331.76px"
    },
    id: "el4csw5tt182q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.37 324.66 230.87 338.36 225.26 338.31 225.56 324.54 231.37 324.66",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "228.315px 331.45px"
    },
    id: "elzhwbwlbifrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj4mq2pb7op8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.72,
    y: 354.46,
    width: 18.66,
    height: 23.55,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "289.05px 366.235px",
      transform: "rotate(-179.55deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "291.18 355.22 290.85 378.03 287.9 378.01 288.53 355.2 291.18 355.22",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "289.54px 366.615px"
    },
    id: "elenypk8li3qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.1 355.05 279.81 355.13 298.47 355.28 279.79 357.74 279.63 377.94 268.93 377.86 269.1 355.05",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "283.7px 366.495px"
    },
    id: "elfkmy0ejdywi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.93 355.1 274.51 377.9 271.33 377.88 271.85 355.07 274.93 355.1",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "273.13px 366.485px"
    },
    id: "elyxepsekk98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.4,348.15c0,.35-1.22.77-3.36,1a12.2,12.2,0,0,1-3.91-.32,2.64,2.64,0,0,1-1.51-1,2.28,2.28,0,0,1-.35-1.15,3.91,3.91,0,0,1,.09-.86,14.09,14.09,0,0,1,.73-2.41,7.13,7.13,0,0,1,.71-1.25A4.43,4.43,0,0,1,277,341a2.62,2.62,0,0,1,2-.34,3.53,3.53,0,0,1,1.37.76,10.33,10.33,0,0,1,2.46,3.1c1,2,.86,3.49.53,3.54s-.87-1.09-2.08-2.54a12.62,12.62,0,0,0-2.39-2.21,1.22,1.22,0,0,0-.45-.23h0v0l-.07.05a2.17,2.17,0,0,0-.43.48,4,4,0,0,0-.42.77,15,15,0,0,0-.63,2l-.06.23-.16,0-.15,0c-.07,0-.08,0,0,0a.71.71,0,0,0,.18-.16l.06-.06h0v0a1,1,0,0,0,.22.12,17.44,17.44,0,0,0,3.21.75C282.09,347.55,283.4,347.78,283.4,348.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "278.937px 344.89px"
    },
    id: "el3k73auitv17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,348.33c-.07-.4,1.32-.93,3.46-1.64a35.18,35.18,0,0,0,3.6-1.37,3.33,3.33,0,0,0,.71-.41c.06-.05.06-.09,0,0a.6.6,0,0,0-.07.28l-.37-.78a9.58,9.58,0,0,0-.55-1,3.37,3.37,0,0,0-.6-.72,2,2,0,0,0-.59-.42.48.48,0,0,0-.31,0,1.23,1.23,0,0,0-.54.3,15.21,15.21,0,0,0-2.55,2.64c-1.29,1.69-1.71,3.05-2.12,3s-.66-1.66.38-4a12,12,0,0,1,2.56-3.61,4.07,4.07,0,0,1,1.44-.92,3.15,3.15,0,0,1,2.08,0,3.8,3.8,0,0,1,.86.41,5.82,5.82,0,0,1,.68.52,6.34,6.34,0,0,1,1.08,1.25,12.49,12.49,0,0,1,.72,1.31l.27.61a3.74,3.74,0,0,1,.31,1,2.28,2.28,0,0,1-.26,1.47,2.78,2.78,0,0,1-.79.88,5.44,5.44,0,0,1-1.36.67,18.23,18.23,0,0,1-4.17.92C284.53,348.88,283.08,348.7,283,348.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "288.097px 344.141px"
    },
    id: "eluw2mhbftp1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwsnh6x6cbdd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 347.33,
    width: 27.43,
    height: 7.8,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.455px 351.23px",
      transform: "rotate(-179.55deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elspuc72ci52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.82,
    y: 347.4,
    width: 24.79,
    height: 7.8,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "288.215px 351.3px",
      transform: "rotate(-179.55deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "293.04 347.44 292.87 355.27 289.97 355.21 290.18 347.42 293.04 347.44",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "291.505px 351.345px"
    },
    id: "elx79obcrcfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.5 347.32 272.22 355.08 269.04 355.06 269.21 347.25 272.5 347.32",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "270.77px 351.165px"
    },
    id: "eldp6exyvenmg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14",
    className: "animable",
    style: {
      transformOrigin: "422.459px 430.737px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.45,397.81a12.41,12.41,0,0,1,6.43,7.28,21.82,21.82,0,0,1,.85,9.87c-.72,6.4-4.36,12.86-8.27,18-5.39-4.7-6.63-12.91-7-17.11-.58-6.64,2.4-19,8-18",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "422.171px 415.376px"
    },
    id: "elgxekz53np66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.72,443.5a10.58,10.58,0,0,1,3.42-10.06,14,14,0,0,1,10.36-3.24c1.72.13,3.57.63,4.55,2a4.52,4.52,0,0,1,.07,4.59,9.13,9.13,0,0,1-3.39,3.34c-4.67,2.93-9.73,4.91-15,3.33",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "437.112px 437.078px"
    },
    id: "elk7lbnrhotos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,463.12a7.64,7.64,0,0,1,.19-1.31c.17-.93.39-2.12.65-3.56a37.19,37.19,0,0,1,3.67-11.35,22.75,22.75,0,0,1,8.15-8.66,15.54,15.54,0,0,1,3.32-1.47c.41-.14.74-.19,1-.25s.34-.06.34,0a21.07,21.07,0,0,0-12.36,10.64,39.87,39.87,0,0,0-3.75,11.2c-.33,1.49-.6,2.7-.8,3.52A7.54,7.54,0,0,1,420.81,463.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "429.47px 449.797px"
    },
    id: "el85ilswkxc5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,407.42a2.45,2.45,0,0,1,.07.58c0,.42.06,1,.1,1.65.07,1.43.16,3.5.24,6.07.16,5.13.29,12.22.26,20s-.22,14.92-.44,20.05c-.1,2.57-.2,4.64-.29,6.07-.05.68-.08,1.22-.11,1.65s0,0,0,0c.07-.57-.1.37-.1,0s0-1,0-1.66c0-1.49.08-3.55.14-6.07.13-5.13.27-12.21.31-20s-.05-14.91-.13-20c0-2.52-.07-4.59-.1-6.08,0-.68,0-1.22,0-1.65A4.36,4.36,0,0,1,421,407.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "421.202px 435.551px"
    },
    id: "elxkamvahusnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.4,447.39a24.78,24.78,0,0,0-13.52-18.13c-1.8-.86-4.15-1.43-5.63-.09s-1.16,3.75-.43,5.62a21.16,21.16,0,0,0,19.45,13.13",
    style: {
      fill: "rgb(255, 114, 94)",
      transformOrigin: "408.303px 438.146px"
    },
    id: "ellh0u0fyk0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.75,435.33a6.19,6.19,0,0,1,1.15.5,11.39,11.39,0,0,1,1.29.69,17.64,17.64,0,0,1,1.64,1,20.71,20.71,0,0,1,1.89,1.42,23.39,23.39,0,0,1,2,1.82,27.44,27.44,0,0,1,3.81,4.89,27,27,0,0,1,2.5,5.67,22.74,22.74,0,0,1,.64,2.63,19.88,19.88,0,0,1,.32,2.33c.1.72.06,1.37.09,1.94a11,11,0,0,1,0,1.47,6.68,6.68,0,0,1-.14,1.24c-.11,0,.07-1.78-.24-4.61a22.24,22.24,0,0,0-.37-2.3c-.15-.82-.41-1.68-.67-2.58a27.47,27.47,0,0,0-2.5-5.55,28.19,28.19,0,0,0-3.71-4.83,25,25,0,0,0-1.94-1.83c-.62-.56-1.26-1-1.83-1.44C407.33,436.16,405.7,435.42,405.75,435.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.427px 448.13px"
    },
    id: "el2qzlko5pekn",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlementHistory);
export default __webpack_public_path__ + "static/media/SettlementHistory.d746fe48.svg";
export { ForwardRef as ReactComponent };